import React, { useState, useEffect } from 'react'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/dist/style.css'

import { Wrapper } from './styles'
import { Error, Label, RequiredTag, SubLabel } from '../InputLabels/InputLabels'

const DatePicker = ({
  field = {},
  form: { errors = {} } = {},
  onDayChange,
  label,
  requiredField,
  subLabel,
  setFieldValue,
  values = {},
  ...props
}) => {
  const [selectedDay, setSelectedDay] = useState(field.value)
  const [isPickerOpen, setIsPickerOpen] = useState(false)
  const displayableLabel = requiredField ? `${label} *` : label
  const hasError = !!errors[field.name]

  // Update selectedDay when field.value changes
  useEffect(() => {
    setSelectedDay(field.value)
  }, [field.value])

  const handleDayClick = day => {
    setSelectedDay(day)
    setFieldValue(field.name, day)
    setIsPickerOpen(false) // Close the picker

    if (onDayChange) {
      onDayChange(day)
    }
  }

  const fieldName = field.name
  const initialValue = values[fieldName] || undefined
  const initialValueFormatted = initialValue
    ? initialValue.replace(/-/g, '/').replace(/T.+/, '')
    : undefined

  return (
    <Wrapper disabled={props.disabled} hasError={hasError} requiredField={requiredField}>
      {label && !hasError && <Label htmlFor={field.name}>{displayableLabel}</Label>}
      {subLabel && <SubLabel subLabel={subLabel}>{subLabel}</SubLabel>}

      <RequiredTag hasError={hasError} label={label} requiredField={requiredField} />

      {errors[field.name] && <Error>{errors[field.name]}</Error>}

      <input
        {...field}
        {...props}
        onFocus={() => setIsPickerOpen(true)}
        value={selectedDay ? selectedDay.toLocaleDateString() : initialValueFormatted}
        readOnly // Optional: makes the input field read-only
      />

      {isPickerOpen && <DayPicker mode="single" selected={selectedDay} onSelect={handleDayClick} />}
    </Wrapper>
  )
}

export default DatePicker
